import { render, staticRenderFns } from "./SiteAffiliate.vue?vue&type=template&id=0b79336e"
import script from "./SiteAffiliate.vue?vue&type=script&lang=js"
export * from "./SiteAffiliate.vue?vue&type=script&lang=js"
import style0 from "./SiteAffiliate.vue?vue&type=style&index=0&id=0b79336e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports